// src/pages/paxTypes/PaxTypes.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import PaxTypesTable from "../../components/paxTypes/PaxTypesTable";

const PaxTypes = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table PaxTypes */}
            <PaxTypesTable />
        </WrapperSection>
    );
};

export default PaxTypes;